export const sizeTinyHeader = "X4d";
export const sizeSmallHeader = "Y4d";
export const sizeMediumHeader = "Z4d";
export const sizeLargeHeader = "_4d";
export const sizeVeryLargeHeader = "$4d";
export const sizeHugeHeader = "a5d";
export const sizeEnormousHeader = "b5d";
export default {sizeTinyHeader,sizeSmallHeader,sizeMediumHeader,sizeLargeHeader,sizeVeryLargeHeader,sizeHugeHeader,sizeEnormousHeader};